import { Component } from '@angular/core';
import { BannerComponent } from 'app/shared/components/banner/banner.component';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { Themes } from 'themes';

@Component({
  selector: 'ez-already-sent',
  imports: [BannerComponent, MainLayoutComponent],
  templateUrl: './already-sent.component.html',
  styleUrl: './already-sent.component.scss',
})
export class AlreadySentComponent {
  Themes = Themes;
}
